module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b8f6H"))).then(() => parcelRequire('dJXJK'));